import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import DeleteIcon from "@mui/icons-material/Delete";
//import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import { deleteUser } from "rest/requests";
import swal from "sweetalert";

const ITEM_HEIGHT = 48;

export default function UsersActionMenu({ setIsEditingUsers, element, setElementToEdit }) {
  const rowElement = element;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const edit = () => {
    setAnchorEl(null);
    if (setIsEditingUsers !== null) {
      setIsEditingUsers(true);
      setElementToEdit(rowElement);
    }
  };

  const deleteUserFunction = () => {
    swal({
      title: "Confirmación antes de desactivar",
      text: "Una vez desactivado el usuario solo un super admin podra reestablecerlo",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteUser(element.id)
          .then((req, res) => {
            console.log("Success..", res);
            swal("El usuario ha sido eliminado exitosamente", {
              icon: "success",
            });
            setIsEditingUsers(null);
            setIsEditingUsers(false);
          })
          .catch((error) => {
            console.log("Error...", error);
            swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
          });
      } else {
        swal("El proceso de eliminacion a sido detenido. Su usuario esta a salvo!");
      }
    });
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem key="Editar" onClick={edit}>
          <EditIcon color="success" />
          &nbsp;Editar
        </MenuItem>
        <Divider />
        <MenuItem key="Eliminar" onClick={() => deleteUserFunction()}>
          <DeleteIcon color="primary" />
          &nbsp;Eliminar
        </MenuItem>
        <Divider />
        {/* <MenuItem key="Agregar" onClick={add}>
          <AddIcon color="dark" />
          &nbsp;Agregar
        </MenuItem>
        <Divider /> */}
      </Menu>
    </div>
  );
}

UsersActionMenu.defaultProps = {
  setIsEditingUsers: null,
  element: {},
  setElementToEdit: null,
};

UsersActionMenu.propTypes = {
  setIsEditingUsers: PropTypes.any,
  element: PropTypes.object,
  setElementToEdit: PropTypes.func,
};
